<template>
  <v-autocomplete
    :value="boundValue"
    :items="options"
    :label="label"
    :class="inputClass"
    :name="name"
    :rules="required ? rules.required : []"
    :error-messages="errorMessages"
    :disabled="disabled"
    :hide-details="hideDetails"
    item-text="name"
    item-value="id"
    persistent-hint
    @input="$emit('input', $event)"
  />
</template>

<script>
/**
 * Campo de catálogo reutilizable (usuario, proyecto, tipo de viaje, vehículo,
 * validador...). Mantiene el mismo v-autocomplete del diseño original, pero no
 * depende de que el catálogo esté cargado: si el back sólo manda el nombre ya
 * resuelto, lo inyecta como opción sintética para poder mostrarlo.
 */
const DISPLAY_ONLY_ID = '__display_only__'

export default {
  name: 'LookupField',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    /** Nombre ya resuelto por el back; se usa cuando no hay catálogo. */
    displayName: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    },
    /** Se propaga al input real para poder identificarlo desde la vista. */
    name: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    rules () {
      return this.$validationRules()
    },
    hasCatalogMatch () {
      return this.items.some(item => item && item.id === this.value)
    },
    /** Id realmente enlazado: el real, o uno sintético cuando sólo hay nombre. */
    boundValue () {
      if (this.hasCatalogMatch) return this.value
      if (!this.displayName) return this.value
      return this.value !== null && this.value !== undefined ? this.value : DISPLAY_ONLY_ID
    },
    options () {
      if (this.hasCatalogMatch || !this.displayName) return this.items
      return this.items.concat([{ id: this.boundValue, name: this.displayName }])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requests/LookupField.vue